import React from 'react';
import styles from './style.module.css';
import InfoBox from '../../../../common/components/info-box';
import IframeResize from "../../../../common/components/iframe-resize";

const ctaButton = {
        link: 'https://libro.coconutcalendar.com/service',
        label: 'Book A Meeting',
        target: '_blank',
};

const tooltip = {
        title: 'Looking for a professional opinion?',
        content: 'Connect with a Libro Coach to find out how we can help you build your own financial happiness.',
        button: ctaButton
};

const wrapperStyles = {
        maxWidth: "34rem",
        margin: "0 auto"
};

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Loan Payment Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/loan-calculator/" title="Loan Payment Calculator" scrolling="no" frameBorder="0" className={styles.reducedHeight}> </iframe>
        <IframeResize />
        <div className="wrapper" style={wrapperStyles}>
            <InfoBox
                title={tooltip.title}
                content={tooltip.content}
                button={tooltip.button}
            />
        </div>
    </div>
);
